import { render, staticRenderFns } from "./SpecialistManagement.vue?vue&type=template&id=32ce9257&scoped=true"
import script from "./SpecialistManagement.vue?vue&type=script&lang=js"
export * from "./SpecialistManagement.vue?vue&type=script&lang=js"
import style0 from "./SpecialistManagement.vue?vue&type=style&index=0&id=32ce9257&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce9257",
  null
  
)

export default component.exports